import axios from 'axios';
import { useState } from 'react';
import { useAuthContext } from './useAuthContext';
import { useAccountContext } from './useAccountContext';
import { useSettingsContext } from "./useSettingsContext";

export const userRights = () => {
    const { user, clientApi, username } = useAuthContext();
    const { dispatch } = useAccountContext();
    const [isLoading, setIsLoading] = useState(false);
    const { isWinAuth } = useSettingsContext();

    const axiosInstance = axios.create({
        baseURL: `${clientApi}`,
        headers: {
            'accepts': 'application/json',
            'Content-Type': 'application/json',
        },
    });

    axiosInstance.interceptors.request.use(request => {
        const accessToken = user.token;
        if (accessToken) {
            request.headers['Authorization'] = `Bearer ${accessToken}`;
        }
        return request;
    }, error => {
        return Promise.reject(error);
    });

    axiosInstance.interceptors.response.use(
        response => response, // Directly return successful responses.
        async error => {
            console.log('Refresh Access Token Expired!!!')
            const originalRequest = error.config;
            if (error.response.status === 401 && !originalRequest._retry) {
                originalRequest._retry = true; // Mark the request as retried to avoid infinite loops.
                try {
                    if (!isWinAuth) {
                        // Make a request to your auth server to refresh the token.
                        const response = await axiosInstance.post(`${clientApi}api/auth/refresh`, user);
                        // Store the new access and refresh tokens.
                        authDispatch({ type: 'Refresh', payload: response.data, clientApi: clientApi, username: username });

                        // Update the authorization header with the new access token.
                        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${response.data.token}`;
                    }
                    else {
                        const newToken = await acquireSilentToken();
                        let tmpUser = user;
                        tmpUser.token = newToken;
                        authDispatch({ type: 'REFRESH', payload: tmpUser, clientApi: clientApi, username: username });
                        axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
                    }
                    return axiosInstance(originalRequest); // Retry the original request with the new access token.
                } catch (refreshError) {
                    // Handle refresh token errors by clearing stored tokens and redirecting to the login page.
                    console.error('Token refresh failed:', refreshError);
                    authDispatch({ type: 'LOGOUT' });
                    return Promise.reject(refreshError);
                }
            }
            return Promise.reject(error); // For all other errors, return the error as is.
        }
    );

    //* This is specific for reporitng will not substitue with context for now. s
    const getVisibleScreens = async () => {
        setIsLoading(true)
        await axiosInstance.get(`${clientApi}api/userroles/GetVisibleScreens`, {
            params: { username: username }
        }).then((resp) => {
            setIsLoading(false)
            dispatch({ type: 'UPDATE_REP_USERROLES', payload: resp.data })
        }).catch((error) => {
            setIsLoading(false)
            console.log(error)
        })
    }


    return { getVisibleScreens, isLoading }
}
